import { z } from "zod";

import { basePrayerInCollectionSchema } from "../../../../../lib/types/schema/prayer/basePrayerInCollectionSchema";

const prayerInCollectionSchemaWithDateAvailable =
  basePrayerInCollectionSchema.extend({
    date_available: z.iso.datetime().nullable(),
  });

export const collectionPrayersSchema = z.array(
  prayerInCollectionSchemaWithDateAvailable,
);

export type CollectionPrayers = z.TypeOf<typeof collectionPrayersSchema>;
